<template>
    <v-card width="100%" class="ma-0 pa-0" outlined>
        <v-card-actions class="ma-0 pa-0">
            <v-list>
                <template v-for="(item, index) in mergeHistory">
                    <v-list-item :key="index">
                        <v-card elevation="0" class="mv-1">
                            <v-chip small outlined
                                    text-color="black">
                                {{ item.date | formatDate }}
                            </v-chip>
                        </v-card>
                        <v-card elevation="0" class="mv-1 ml-2">
                            <v-chip color="blue" small
                                    text-color="white">
                                <v-chip color="white"
                                        x-small
                                        text-color="black">
                                    {{ getOwner(getDataByName(item.data, "a").owner)}}
                                </v-chip>
                                <v-chip color="blue"
                                        small
                                        text-color="white">
                                    {{ getDataByName(item.data, "a").uid }}
                                </v-chip>
                                <v-btn icon color="white" class="mx-n3" @click="editConfig(getDataByName(item.data, 'a').data_path)">
                                    <v-icon color="white" size="15">mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn icon color="white" class="mr-n2" @click="exportConfig(getDataByName(item.data, 'a'))">
                                    <v-icon color="white" size="15">mdi-content-copy</v-icon>
                                </v-btn>
                            </v-chip>
                        </v-card>
                        <v-icon>mdi-plus</v-icon>
                        <v-card elevation="0" class="mv-1">
                            <v-chip color="blue" small
                                    text-color="white">
                                <v-chip color="white"
                                        x-small
                                        text-color="black">
                                    {{ getOwner(getDataByName(item.data, "b").owner)}}
                                </v-chip>
                                <v-chip color="blue"
                                        small
                                        text-color="white">
                                    {{ getDataByName(item.data, "b").uid }}
                                </v-chip>
                                <v-btn icon color="white" class="mx-n3" @click="editConfig(getDataByName(item.data, 'b').data_path)">
                                    <v-icon color="white" size="15">mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn icon color="white" class="mr-n2" @click="exportConfig(getDataByName(item.data, 'b'))">
                                    <v-icon color="white" size="15">mdi-content-copy</v-icon>
                                </v-btn>
                            </v-chip>
                        </v-card>
                        <v-icon>mdi-equal</v-icon>
                        <v-card elevation="0" class="mv-1">
                            <v-chip color="green" small
                                    text-color="white">
                                <v-chip color="white"
                                        x-small
                                        text-color="black">
                                    {{ getOwner(getDataByName(item.data, "c").owner)}}
                                </v-chip>
                                <v-chip color="green"
                                        small
                                        text-color="white">
                                    {{getDataByName(item.data, "c").uid}}
                                </v-chip>
                                <v-btn icon color="white" class="mx-n3" @click="editConfig(getDataByName(item.data, 'c').data_path)">
                                    <v-icon color="white" size="15">mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn icon color="white" class="mr-n2" @click="exportConfig(getDataByName(item.data, 'c'))">
                                    <v-icon color="white" size="15">mdi-content-copy</v-icon>
                                </v-btn>
                            </v-chip>
                        </v-card>
                    </v-list-item>
                </template>
            </v-list>
        </v-card-actions>
    </v-card>
</template>

<script>

import {ConfigStoreUtils} from "@/modules/mconfigs/database/ConfigStoreUtils";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";
import {ConfigModel} from "@/modules/mconfigs/models/ConfigModel";

export default {
    name: "merge-history-table",
    data: () => ({}),
    methods: {
        exportConfig(data) {
            let configCopy = new ConfigModel("from_history_" + data.uid, data.mapId)
            ConfigStoreUtils.getConfigData("/merge_history/merge_data/" + data.data_path)
                .then((data) => {
                    ConfigStoreUtils.pushConfig(configCopy, data).then(() => {
                        this.$notify({title: 'Config successfully copied!', text: "", type: "succes"});
                    }).catch((error) => {
                        this.$notify({title: 'Config copied failed!', text: error, type: "error"});
                    })
                }).catch((error) => {
                this.$notify({title: 'Failed to get config data to copy!', text: error, type: "error"});
            })
        },
        editConfig(data_path) {
            let path = "/merge_history/merge_data/" + data_path;
            this.$router.push({name: "m-redactor", params: {path: path, readonly: true, name: data_path}});
        },
        getDataByName(data, name) {
            return data.filter(e=>e.name == name)[0];
        },
        getOwner(uid) {
            return PermissionsStoreUtils.getUserName(uid)
        },
    },
    computed: {
        mergeHistory() {
            return ConfigStoreUtils.getMergeHistory().map(e=>e.clone()).sort((a,b) => a.date - b.date).reverse();
        }
    }
}
</script>

<style scoped>
</style>